import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetAllExamTypes({ enabled = false } = {}) {
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    ['exam-types-all'],
    () => privateFetch.get('/v1/admin/manage-podcasts/exam-info/exam-types').then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetAllExamTypes;
